import React from 'react';
import './authenticated-header.scss';
import { WorkdayLogo } from '../workdayLogo/workday-logo';
import { HeaderMenu, MenuContentFn } from '../headerMenu/HeaderMenu';
import { useLoadedInApp } from '../../hooks/useLoadedInAppHook';
import { questionFillIcon } from '@workday/canvas-system-icons-web';
import { TertiaryButton } from '@workday/canvas-kit-react/button';
import { autoId } from '../../utils/AutomationUtil';
import classNames from 'classnames';

interface AuthenticatedHeaderProps {
    title: string;
    profileImageUrl?: string;
    faqUrl?: string;
    variant?: 'inverse' | undefined;
    menuContent?: MenuContentFn;
    onLogoClick?: () => void | undefined;
}

export const AuthenticatedHeader = ({
    faqUrl,
    menuContent,
    variant,
    onLogoClick,
    profileImageUrl
}: AuthenticatedHeaderProps) => {
    const isLoadedInApp = useLoadedInApp();
    const isInverse = variant === 'inverse';

    if (isLoadedInApp) {
        return null;
    } else {
        return (
            <header
                {...autoId('authenticatedHeader')}
                className={classNames('authenticatedHeader', isInverse && 'authenticatedHeaderInverse')}>
                <WorkdayLogo className='authenticatedHeader__logo' onClick={onLogoClick} isInverse={isInverse} />
                <div className='authenticatedHeader__rightContent'>
                    <div className='authenticatedHeader__quickLinks'>
                        {faqUrl && (
                            <TertiaryButton
                                as='a'
                                icon={questionFillIcon}
                                size='small'
                                target='_blank'
                                {...autoId('faqButton')}
                                rel='noopener noreferrer'
                                variant={variant}
                                href={faqUrl}
                            />
                        )}
                    </div>
                    {menuContent && (
                        <HeaderMenu variant={variant} menuContent={menuContent} profileImageUrl={profileImageUrl} />
                    )}
                </div>
            </header>
        );
    }
};
